import { type FC } from 'react'
import { Outlet } from 'react-router-dom'

import NotificationsContainer from './notifications/NotificationsContainer'

const RootLayout: FC = () => (
  <>
    <NotificationsContainer />
    <Outlet />
  </>
)

export default RootLayout
